import { UserDetails } from '@weave/schema-gen-ts/dist/schemas/auth-api/v3/auth.pb';
import { i18next } from '@frontend/i18n';
import { getFullName } from '@frontend/name';
import { Avatar } from '@frontend/design-system';

export const getAssigneeDetails = (
  assignee: UserDetails[],
  assigneeFilter: string | '',
  isWeaveUser?: boolean
): { name: string; AvatarComponent?: () => JSX.Element } => {
  if (!assigneeFilter || isWeaveUser) {
    const title = i18next.t('All Tasks', { ns: 'task-center' });
    return { name: title };
  } else {
    const user = assignee.find((assign) => assign.userId === assigneeFilter);
    const fullName = getFullName(user ?? {});

    return { name: fullName, AvatarComponent: () => <Avatar isUser name={fullName} size='xxs' /> };
  }
};
